import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper';

let heroSwiper = null; 

const setHeroSlider = () => {
  const target = document.querySelector('.js-hero-slider');
  if (!target) return;

  heroSwiper = new Swiper(target, { 
    modules: [Autoplay, EffectFade],
    autoplay: {
      delay: 1500,
      disableOnInteraction: false,
    },
    speed: 2000,
    loop: true,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    slidesPerView: 1,
  });

  heroSwiper.autoplay.stop(); 
};

const getHeroSwiper = () => heroSwiper;

export { setHeroSlider, getHeroSwiper };
